import { useState, ChangeEvent } from "react";
import { DatePicker, Input, Button, Spin, Card } from "antd";

import DeleteOutlined from "@ant-design/icons/DeleteOutlined";
import { useAPI } from "../lib/hook/APIProvider";
import { useModal } from "../lib/modal/ModalContext";
import DataCompareModal from "./DataCompareModal";
const DeleteACar: React.FC = () => {
  const [carNumber, setCarNumber] = useState("");
  const [loading, setLoading] = useState(false);
  const { client } = useAPI();

  const {showModal,hideModal} = useModal();

  const handleDelete = async () => {
    setLoading(true);
    if (!carNumber) {
      window.alert("차량번호를 입력해주세요.");
      hideModal();
      setLoading(false);
      return;
    }

    try {
      const result = await client.delete(
        `preview/ivis/IndvReduction?isPreview=true&key=vin`,
        { data:[ { vin: carNumber } ]}
      );
      console.log(result.data);

      showModal(
        <>
          <DataCompareModal
            onApplyData={
              async () => {
                try {
                  const result2 = await client.delete(
                    `preview/ivis/IndvReduction?isPreview=false&key=vin`,
                    { data:[ { vin: carNumber } ]}
                  );

                } catch (err) {
                  window.alert(`삭제 중 오류 발생: ${err instanceof Error ? err.message : String(err)}`);
                } finally {
                  hideModal();
                  setLoading(false);
                  window.location.reload();
                }
              }
            }
            before={result.data.before}
            after={result.data.after}
            history={result.data.history}
          />
        </>
      );
    } catch (err) {
      window.alert(`삭제 중 오류 발생: ${err instanceof Error ? err.message : String(err)}`);
    } finally {

    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setCarNumber(e.target.value);
  };

  return (
    <div className="flex flex-col h-screen w-full bg-gray-300 overflow-y-clip">
      <div className="min-h-screen flex justify-center items-center bg-gray-100">
        <div style={{ display: "flex", flexDirection: "column", gap: 32, width: 400 }}>
          <Card title="차량 삭제" style={{ width: 400 }}>
            <div style={{ display: "flex", gap: 8 }}>
              <Input
                style={{ flex: 1 }}
                placeholder="차량번호 입력"
                value={carNumber}
                onChange={handleInputChange}
                disabled={loading}
                allowClear
              />
              <Button
                type="primary"
                danger
                loading={loading}
                onClick={handleDelete}
                icon={<DeleteOutlined />}
              >
                삭제
              </Button>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default DeleteACar;
